import React from "react";
import { css, Theme, useTheme } from "@emotion/react";

import LabelledField from "core/Components/Form/LabelledField";

type Props = {
    children: React.ReactNode,
    error?: string,
    name: string,
    label?: string,
    errorAsterisk?: boolean,
    labelWidth?: string,
    labelLeft?: string,
    className?: string,
};

const FormLabelledField: React.FC<Props> = ({
    children,
    error,
    name,
    label,
    errorAsterisk,
    labelWidth,
    labelLeft,
    className,
}) => {
    const theme: Theme = useTheme();

    const style = css`
        width: 100%;
        text-align: left;
        display: flex;
        justify-content: space-between;

        flex-direction: column;
        align-items: flex-start;
        
        label, input {
            font-size: 14px;
    
            ${theme.breakpoints.up("5xl")} {
                font-size: 16px;
            }
    
            ${theme.breakpoints.down("md")} {
                font-size: 12px;
            }
        }
        
        label {
            width: 100%;
            
            ${labelWidth && css`
                width: ${labelWidth};
            `};

            ${labelLeft && css`
                left: ${labelLeft};
            `};
        }
    `;

    return (
        <LabelledField
            name={name}
            error={error}
            label={label}
            css={style}
            errorAsterisk={errorAsterisk}
            className={className}
        >
            {children}
        </LabelledField>
    );
};

export default FormLabelledField;
